(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('GFileClients', GFileClients);

    GFileClients.$inject = ['$resource'];

    function GFileClients ($resource) {
        var resourceUrl =  'api/clients';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
